const INVALID_MESSAGE =
  'Ingresá un teléfono argentino válido (ej: 11 2345 6789 o 9 351 123 4567).';

/**
 * Strip formatting and normalize Argentine numbers toward national digits (no +54).
 */
export function digitsOnlyArgentina(value) {
  let digits = String(value).replace(/\D/g, '');
  if (digits.startsWith('54')) digits = digits.slice(2);
  while (digits.startsWith('0')) digits = digits.slice(1);
  // Domestic mobile prefix 15 between area code and subscriber number
  digits = digits.replace(/^(\d{2,4})15(\d+)/, '$1$2');
  return digits;
}

/**
 * @param {string} value
 * @returns {{ valid: boolean, e164: string|null, message?: string }}
 */
export function validateArgentinaPhone(value) {
  if (!value || !String(value).trim()) {
    return { valid: true, e164: null };
  }

  const digits = digitsOnlyArgentina(value);

  if (digits.length < 10 || digits.length > 11) {
    return { valid: false, e164: null, message: INVALID_MESSAGE };
  }

  const isMobile =
    digits.startsWith('9') && digits.length >= 10 && digits.length <= 11;
  const isLandline =
    !digits.startsWith('9') && digits.length === 10 && /^[1-8]\d{9}$/.test(digits);

  if (!isMobile && !isLandline) {
    return { valid: false, e164: null, message: INVALID_MESSAGE };
  }

  return { valid: true, e164: `+54${digits}` };
}

/** Live input: digits, spaces, +, parentheses, hyphens — capped length */
export function sanitizePhoneInput(value) {
  return String(value)
    .replace(/[^\d+\s()-]/g, '')
    .slice(0, 24);
}

/** Format national digits for display (after blur). */
export function formatPhoneDisplay(value) {
  const digits = digitsOnlyArgentina(value);
  if (!digits) return '';

  if (digits.startsWith('9')) {
    const chunks = [digits.slice(0, 1), digits.slice(1, 3), digits.slice(3, 7), digits.slice(7)];
    return chunks.filter(Boolean).join(' ').trim();
  }

  const chunks = [digits.slice(0, 2), digits.slice(2, 6), digits.slice(6)];
  return chunks.filter(Boolean).join(' ').trim();
}
